var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Footer',{attrs:{"spList":_vm.spList,"toolsList":_vm.toolsList,"settingList":_vm.settingList,"otherList":_vm.otherList},on:{"goToHome":_vm.goToHome,"logout":_vm.logout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }